import { render, staticRenderFns } from "./waterjetBed.vue?vue&type=template&id=52b41233&scoped=true&"
import script from "./waterjetBed.vue?vue&type=script&lang=js&"
export * from "./waterjetBed.vue?vue&type=script&lang=js&"
import style0 from "./waterjetBed.vue?vue&type=style&index=0&id=52b41233&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b41233",
  null
  
)

export default component.exports